import { Action } from '../../shared/xs/actions';

export class RefreshImprovementsAction implements Action {
  static readonly type = '[Improvements] Refresh';
}
